import { httpClient, IHttpClient } from '@api'
import { TSellResponse } from '@api/types'

import { TSellSenderInfoResponse } from '../types/sell/TSellSenderInfoResponse'
import { TBank } from '../types/TBank'
import { TFullName } from '../types/TFullName'

interface ISellApplicationClient {
  getSender(paymentPublicId: string): Promise<TSellSenderInfoResponse>

  getNspkBanks(): Promise<TBank[]>

  getBanks(paymentGatewayId: string): Promise<TBank[]>

  sell(
    applicationId: string,
    amountFrom: string,
    amountTo: string,
    receiver: string,
    nspkBankId: string,
    phone: string,
    paymentGatewayId: string,
  ): Promise<TSellResponse>

  sellCard(
    applicationId: string,
    amountFrom: string,
    amountTo: string,
    receiver: string,
    bankCardNumber: string,
    paymentGatewayId: string,
  ): Promise<TSellResponse>

  sellImps(
    applicationId: string,
    amountFrom: string,
    amountTo: string,
    impsAccount: string,
    impsAccountNum: string,
    ifsc: string,
    senderFullName: TFullName,
    paymentGatewayId: string,
  ): Promise<TSellResponse>

  sellThbVnd(
    applicationId: string,
    amountFrom: string,
    amountTo: string,
    accountHolder: string,
    accountNumber: string,
    bankId: string,
    senderFullName: TFullName,
    paymentGatewayId: string,
  ): Promise<TSellResponse>
}

const sellApplicationClientFactory = (
  client: IHttpClient,
): ISellApplicationClient => {
  return {
    getSender(sellPublicId: string): Promise<TSellSenderInfoResponse> {
      return client.get(
        `/client/v1/sell-applications/sell/${sellPublicId}/sender`,
      )
    },
    // todo: снести
    getNspkBanks(): Promise<TBank[]> {
      return client.get(`/client/v1/sell-applications/nspk-banks`)
    },
    getBanks(paymentGatewayId: string): Promise<TBank[]> {
      return client.get(
        `/client/v1/sell-applications/banks/${paymentGatewayId}`,
      )
    },

    // todo: Сделать один sell, а не кучу разных
    sell(
      applicationId: string,
      amountFrom: string,
      amountTo: string,
      receiver: string,
      nspkBankId: string,
      phone: string,
      paymentGatewayId: string,
    ): Promise<TSellResponse> {
      return client.post(`/client/v1/sell-applications/${applicationId}/sell`, {
        receiver: receiver,
        phone: phone,
        nspkBankId: nspkBankId,
        amountFrom: {
          amount: amountFrom,
        },
        amountTo: {
          amount: amountTo,
        },
        paymentGatewayId: paymentGatewayId,
      })
    },

    sellCard(
      applicationId: string,
      amountFrom: string,
      amountTo: string,
      receiver: string,
      bankCardNumber: string,
      paymentGatewayId: string,
    ): Promise<TSellResponse> {
      return client.post(`/client/v1/sell-applications/${applicationId}/sell`, {
        receiver: receiver.toUpperCase(),
        amountFrom: {
          amount: amountFrom,
        },
        amountTo: {
          amount: amountTo,
        },
        paymentGatewayId: paymentGatewayId,
        toAccount: bankCardNumber,
      })
    },

    sellImps(
      applicationId: string,
      amountFrom: string,
      amountTo: string,
      impsAccount: string,
      impsAccountNum: string,
      ifsc: string,
      senderFullName: TFullName,
      paymentGatewayId: string,
    ): Promise<TSellResponse> {
      return client.post(`/client/v1/sell-applications/${applicationId}/sell`, {
        amountFrom: {
          amount: amountFrom,
        },
        amountTo: {
          amount: amountTo,
        },
        toAccountName: impsAccount,
        toAccount: impsAccountNum,
        ifscCode: ifsc,
        sellerInfo: senderFullName,
        paymentGatewayId: paymentGatewayId,
      })
    },

    sellThbVnd(
      applicationId: string,
      amountFrom: string,
      amountTo: string,
      accountHolder: string,
      accountNumber: string,
      bankId: string,
      senderFullName: TFullName,
      paymentGatewayId: string,
    ): Promise<TSellResponse> {
      return client.post(`/client/v1/sell-applications/${applicationId}/sell`, {
        amountFrom: {
          amount: amountFrom,
        },
        amountTo: {
          amount: amountTo,
        },
        toAccountName: accountHolder,
        toAccount: accountNumber,
        sellerInfo: senderFullName,
        paymentGatewayId: paymentGatewayId,
        bankId: bankId,
      })
    },
  }
}

export const sellApplicationClient: ISellApplicationClient =
  sellApplicationClientFactory(httpClient)
